export const API_URL = "https://qwtoolsapi.azurewebsites.net/"; // PROD
//export const API_URL = "https://localhost:7213/"; // Local

export const CLIENT_VERSION = "Version Beta 0.106 2025-10-31"; //Denna måste stämma överens med klientversionen i servern (Constants.ClientVersion)!!
